import { makeStyles } from '@material-ui/core/styles';

export const useTableStyles = makeStyles((theme) => ({
  fixed: {
    tableLayout: 'fixed',
  },
  row: {
    [theme.breakpoints.down('xs')]: {
      '& th:first-child': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    '& th.MuiTableCell-body': {
      ...theme.typography.body2,
    },
    '& th.MuiTableCell-root': {
      padding: theme.spacing(1.5),
    },
  },
  cell: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dense: {
    padding: 0,
  },
  highlight: {
    '&:hover': {
      [theme.breakpoints.up('sm')]: {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  clickable: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  smUp: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  mdUp: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export const useLayoutStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
  },
  menuIcon: {
    color: theme.palette.action.active,
    marginRight: theme.spacing(2),
  },
  menuDivider: {
    '&.MuiDivider-root': {
      margin: theme.spacing(1, 1.5),
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));
